export default {"src":"/_next/static/media/rating-arrow.2db677fa.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};